import { Component, OnInit, OnDestroy, Input, effect, inject } from '@angular/core';
import { ControlContainer, FormGroup, FormGroupDirective } from '@angular/forms';
import { ErrorStateOnTouched } from '@app/material/ErrorStateOnTouched';
import { MobilePaymentType } from '@sales/enums/mobile-payment-type';
import { Subscription } from 'rxjs';
import { MobilePhoneFormControls } from '../mobilephone-details.component';
import { select } from '@ngxs/store';
import { DealerStateSelectors } from '@app/core/states/dealer/dealer-state.selectors';
import { IceSelectBoxComponent } from '@app/shared/components/molecules/ice-select-box/ice-select-box.component';

@Component({
  selector: 'app-mobilephone-delivery-type',
  templateUrl: './mobilephone-delivery-type.component.html',
  styleUrls: ['./mobilephone-delivery-type.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  imports: [IceSelectBoxComponent],
})
export class MobilephoneDeliveryTypeComponent implements OnInit, OnDestroy {
  formGroupDirective = inject(FormGroupDirective);

  MobilePhoneFormControls = MobilePhoneFormControls;
  MobilePaymentType = MobilePaymentType;

  @Input() canSellHardwareWithLogistics: boolean;
  @Input() mobilePaymentType: MobilePaymentType;
  @Input() isManualRegistration: boolean;

  isRetailPayment = select(DealerStateSelectors.isRetailPayment);

  form: FormGroup;
  subscriptions$: Subscription[] = [];
  matcher = new ErrorStateOnTouched();

  private isFormInitialized = false;

  constructor() {
    effect(() => {
      this.initialize(this.form.get(MobilePhoneFormControls.IsSoldInShop).value);
    });
  }

  ngOnInit() {
    this.form = this.formGroupDirective.form;
    this.subscriptions$.push(
      this.form.get(MobilePhoneFormControls.IsSoldInShop).valueChanges.subscribe(isSoldInShop => {
        this.initialize(isSoldInShop);
      })
    );
  }

  private initialize(isSoldInShop: boolean) {
    if (!this.isFormInitialized) {
      this.isFormInitialized = true;
      if (!this.isRetailPayment()) {
        this.form.get(MobilePhoneFormControls.IsSoldInShop).setValue(false);
      }
    }
    if (isSoldInShop) {
      this.form.get(MobilePhoneFormControls.Imei).enable();
    } else {
      this.form.get(MobilePhoneFormControls.Imei).setValue(null);
      this.form.get(MobilePhoneFormControls.Imei).disable();
    }
  }

  ngOnDestroy() {
    this.subscriptions$.forEach(s => s.unsubscribe());
  }
}
